import script from "./UploadMultipleFilesComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./UploadMultipleFilesComponent.vue?vue&type=script&lang=ts&setup=true"

import "./UploadMultipleFilesComponent.vue?vue&type=style&index=0&id=38d25d96&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\TelAvivMuseum.Web\\museum-telaviv\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38d25d96"]])

export default __exports__